import {css} from 'lit';
export const styles = css`:host {
  --gap: 0;
  --background: transparent;
  --max-height: none;

  display: block;
}

header,
footer {
  display: flex;
  align-items: center;
}

header {
  margin-bottom: 16px;
}

footer {
  margin-top: 8px;
}

slot[name='right']::slotted(*),
slot[name='bottom-right']::slotted(*) {
  margin-left: auto;
}

slot[name='left']::slotted(*),
slot[name='right']::slotted(*) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

slot[name='right']::slotted(*) {
  font-size: var(--font-size-base);
}

slot[name='left']::slotted(*) {
  margin-right: 8px;
  color: var(--dark-text-secondary);
  font-weight: 700;
}

@media (min-width: 768px) {

slot[name='left']::slotted(*) {
    color: var(--dark-text)
}
  }

.section > slot::slotted(*:not(:first-child)) {
    margin-top: var(--gap);
  }

:host([overflow='true']) slot[name='action']::slotted(*) {
    padding-right: var(--page-padding-x);
  }

:host([overflow='true']) .section > slot {
    display: block;
    max-height: var(--max-height);
    overflow-x: auto;
    padding-left: var(--page-padding-x);
    margin-left: calc(var(--page-padding-x) * -1); /* Overflow cut elements */
    padding-right: var(--page-padding-x);
    margin-top: -16px;
    margin-bottom: -16px; /* Overflow cut elements */
    padding-top: 16px;
    padding-bottom: 16px; /* Overflow cut elements */
  }

:host([horizontal='true']) .section {
    margin-bottom: calc(var(--gap) * -1);
  }

:host([horizontal='true']) .section > slot {
    display: flex;
    flex-wrap: wrap;
  }

:host([horizontal='true']) .section > slot::slotted(*) {
      margin-bottom: var(--gap);
    }

:host([horizontal='true']) .section > slot::slotted(*:not(:first-child)) {
      margin-top: 0;
    }

:host([horizontal='true']) .section > slot::slotted(*:not(:last-child)) {
      margin-right: var(--gap);
    }

:host([horizontal='true'][overflow='true']) {
  padding-right: 0;
}

:host([horizontal='true'][overflow='true']) .section > slot {
    flex-wrap: nowrap;
  }

:host([gap='sm']) {
  --gap: 4px;
}

:host([gap='md']) {
  --gap: 8px;
}

:host([gap='lg']) {
  --gap: 16px;
}

:host([gap='xl']) {
  --gap: 32px;
}
`;
export default styles;
